import { gql, useMutation } from '@apollo/client';
import { notification, Typography } from 'antd';
import { getBulkMessage } from 'utils/other';

export const EDIT_TOPIC = gql`
  mutation EditTopic($input: EditTopicInput!) {
    editTopic(input: $input) {
      id
      title
      image
      introduction
      createdBy
      updatedBy
      createdDate
      updatedDate
      isDeleted
      creator {
        id
        name
      }
      updater {
        id
        name
      }
    }
  }
`;

export const ADD_TOPIC = gql`
  mutation AddTopic($input: AddTopicInput!) {
    addTopic(input: $input) {
      id
      title
      image
      introduction
      createdBy
      updatedBy
      createdDate
      updatedDate
      isDeleted
      creator {
        id
        name
      }
      updater {
        id
        name
      }
    }
  }
`;

export const REMOVE_TOPIC = gql`
  mutation RemoveTopic($id: String!) {
    removeTopic(id: $id) {
      id
      title
    }
  }
`;

export const BULK_ACTION_TOPICS = gql`
  mutation BulkActionTopics($input: [BulkActionTopicInput]) {
    bulkActionTopics(input: $input) {
      id
      title
      status
    }
  }
`;

export const useAddTopic = () => {
  const [mutate, { data, error }] = useMutation(ADD_TOPIC, {
    onCompleted: ({ addTopic }) => {
      notification.success({
        message: (
          <Typography.Text>
            Đã tạo nhóm chương trình{' '}
            <Typography.Text strong>{addTopic.title}</Typography.Text>
          </Typography.Text>
        )
      });
    },
    refetchQueries: ['GetTopics']
  });
  return { mutate, data, error };
};

export const useEditTopic = () => {
  const [mutate, { data, error }] = useMutation(EDIT_TOPIC, {
    onCompleted: ({ editTopic }) => {
      notification.success({
        message: (
          <Typography.Text>
            Đã chỉnh sửa nhóm chương trình{' '}
            <Typography.Text strong>{editTopic.title}</Typography.Text>
          </Typography.Text>
        )
      });
    }
  });
  return { mutate, data, error };
};

export const useRemoveTopic = () => {
  const [mutate, { data, error }] = useMutation(REMOVE_TOPIC, {
    refetchQueries: ['GetTopics'],
    onCompleted: ({ removeTopic }) => {
      notification.success({
        message: (
          <Typography.Text>
            Đã xoá nhóm chương trình{' '}
            <Typography.Text strong>{removeTopic.title}</Typography.Text>
          </Typography.Text>
        )
      });
    }
  });
  return { mutate, data, error };
};

export const useBulkTopics = actionField => {
  const [mutate, { data, error }] = useMutation(BULK_ACTION_TOPICS, {
    refetchQueries: ['GetTopics'],
    onCompleted: ({ bulkActionTopics }) => {
      getBulkMessage('nhóm chương trình', bulkActionTopics, actionField);
    }
  });
  return { mutate, data, error };
};
